import { gql } from '@apollo/client';

export const GET_CRAFTING_DATA_FOR_OWNERS_QUERY = gql`
  query GetCraftingDataForOwners($data: CraftingDataForOwnerAddressesInput!) {
    getCraftingDataForOwners(data: $data) {
      tokens
    }
  }
`;
